export type AttendeeType =
  | "adult"
  | "student"
  | "teen"
  | "child_6_12"
  | "child_0_5"
  | "volunteer"
  | "speaker"
  | "organizer"
  | "guest";

export const TYPE_COLORS: Record<AttendeeType, { bg: string; text: string; label: string }> = {
  adult:      { bg: "#0B1F45", text: "#FFFFFF", label: "Adult" },
  student:    { bg: "#F5B301", text: "#0B1F45", label: "Student" },
  teen:       { bg: "#F97316", text: "#FFFFFF", label: "Teen" },
  child_6_12: { bg: "#38BDF8", text: "#0B1F45", label: "Child (6–12)" },
  child_0_5:  { bg: "#38BDF8", text: "#0B1F45", label: "Child (0–5)" },
  volunteer:  { bg: "#7C3AED", text: "#FFFFFF", label: "Volunteer" },
  speaker:    { bg: "#4C1D95", text: "#FFFFFF", label: "Speaker" },
  organizer:  { bg: "#DC2626", text: "#FFFFFF", label: "Organizer" },
  guest:      { bg: "#6B7280", text: "#FFFFFF", label: "Guest" },
};

/**
 * Registration-category → accent color mapping per Southern Region 2026 spec.
 * Attendee type acts as a fallback for members (kids, teens) inside a family
 * registration where the parent category alone doesn't tell us the sub-type.
 */
export const CATEGORY_COLORS: Record<string, { bg: string; text: string; label: string }> = {
  individual: { bg: "#0B1F45", text: "#FFFFFF", label: "Individual" },
  family:     { bg: "#16A34A", text: "#FFFFFF", label: "Family" },
  student:    { bg: "#F5B301", text: "#0B1F45", label: "Student" },
  couple:     { bg: "#7C3AED", text: "#FFFFFF", label: "Couple" },
  teen:       { bg: "#F97316", text: "#FFFFFF", label: "Teen" },
  kids:       { bg: "#38BDF8", text: "#0B1F45", label: "Kids (0–12)" },
};

export function resolveCategoryColor(category: string, attendeeType: AttendeeType) {
  // Sub-type overrides for members inside a family/couple registration
  if (attendeeType === "teen") return CATEGORY_COLORS.teen;
  if (attendeeType === "child_0_5" || attendeeType === "child_6_12") return CATEGORY_COLORS.kids;
  if (attendeeType === "student") return CATEGORY_COLORS.student;

  const key = (category || "").trim().toLowerCase();
  return CATEGORY_COLORS[key] || CATEGORY_COLORS.individual;
}

export const NAVY = "#0B1F45";
export const NAVY_DEEP = "#050F26";
export const GOLD = "#D4A017";
export const GOLD_SOFT = "#E8C15A";

export const ATTENDEE_TYPE_OPTIONS: { value: AttendeeType; label: string }[] = (
  Object.keys(TYPE_COLORS) as AttendeeType[]
).map((v) => ({ value: v, label: TYPE_COLORS[v].label }));
